import { render, staticRenderFns } from "./questionTemplate.vue?vue&type=template&id=22e4604d&scoped=true"
import script from "./questionTemplate.vue?vue&type=script&lang=js"
export * from "./questionTemplate.vue?vue&type=script&lang=js"
import style0 from "./questionTemplate.vue?vue&type=style&index=0&id=22e4604d&prod&scoped=true&lang=css"
import style1 from "./questionTemplate.vue?vue&type=style&index=1&id=22e4604d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e4604d",
  null
  
)

export default component.exports